import { render, staticRenderFns } from "./ProjectSuppliersTab.vue?vue&type=template&id=7a6077d2&scoped=true"
import script from "./ProjectSuppliersTab.vue?vue&type=script&lang=ts"
export * from "./ProjectSuppliersTab.vue?vue&type=script&lang=ts"
import style0 from "./ProjectSuppliersTab.vue?vue&type=style&index=0&id=7a6077d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6077d2",
  null
  
)

export default component.exports